import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const List = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    padding: 0 6px;
    border-bottom: 1px solid ${colours.grey[400]};

    &:last-child {
      border-bottom: none;
    }
  `;
});

export const ListItem = styled.span`
  display: inline-block;
  padding-top: 3px;
  width: 100%;
`;

export const ListItemTitle = styled.div`
  font-weight: 600;
`;

export const Icon = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;

export const Link = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    align-items: center;

    padding: 6px;
    border-bottom: 1px solid ${colours.grey[400]};
    cursor: pointer;

    &:nth-last-child(1) {
      border-bottom: none;
    }

    &:hover {
      background-color: ${colours.grey[100]};

      span {
        background-color: transparent;
      }
    }
  `;
});



// WEBPACK FOOTER //
// ./components/student-list/student-list-item/context-modal-content/styled.js